import React, { useState } from 'react';
import { PageHeader } from '../../components/ui/PageHeader';
import { Panel } from '../../components/ui/Panel';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Meter } from '../../components/ui/Meter';
import { Tabs } from '../../components/ui/Tabs';
import { DataTable } from '../../components/ui/DataTable';
import { auditLog, moderationQueue, platformMetrics, reportedAccounts, supplyDemand, verificationQueue } from '../../data/admin';
import { institutions } from '../../data/institutions';
import { percent } from '../../utils/format';
const TABS = ['Operations', 'Moderation', 'Verification', 'Platform'] as const;
export function PlatformOverview() {
  const [tab, setTab] = useState<(typeof TABS)[number]>('Operations');
  return <div className="space-y-6" data-id="element-7162" data-mp="3pa593ukp54ce">
      <PageHeader eyebrow="Campuzon administration" title="Platform operations" description="Operational administration, moderation, verification and sensitive-data access are deliberately separated. Every action is attributed and logged." data-id="element-7163" data-mp="3p9dh0tqb5oqv" />

      <Tabs tabs={TABS} value={tab} onChange={setTab} label="Admin sections" data-id="element-7164" data-mp="34b0sp6n8habv" />

      {tab === 'Operations' && <div className="space-y-6" data-id="element-7165" data-mp="3943mnfvxalsl">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-7166" data-mp="3e257a58zyt66">
            {platformMetrics.map(metric => <Panel key={metric.label} data-id="element-7167" data-mp="2gfg1dkb6bwf1">
                <p className="cz-num text-2xl font-semibold tracking-tight text-ink" data-id="element-7168" data-mp="2gghdls3xeoyc">
                  {metric.value}
                </p>
                <p className="mt-1 text-[13px] text-ink-muted" data-id="element-7169" data-mp="2qd3xadkin9ys">{metric.label}</p>
                <p className="cz-num mt-1 text-[12px] text-ink-subtle" data-id="element-7170" data-mp="2vbx981k5mswu">{metric.delta}</p>
              </Panel>)}
          </div>

          <div className="grid gap-6 lg:grid-cols-2" data-id="element-7171" data-mp="5ljv6fl2jjyu">
            <Panel title="{housing} supply and demand" description="Aggregated market view — never individual students." bodyClassName="p-0" data-id="element-7172" data-mp="5oy11xsxybb1">
              <ul className="divide-y divide-line" data-id="element-7173" data-mp="26qnqr7bqt16v">
                {supplyDemand.map(row => <li key={row.city} className="flex items-center gap-4 px-5 py-3.5" data-id="element-7174" data-mp="21s4578129rf1">
                    <p className="w-24 shrink-0 text-[13px] font-medium text-ink" data-id="element-7175" data-mp="2fnervy55j68b">{row.city}</p>
                    <div className="min-w-0 flex-1" data-id="element-7176" data-mp="2blt95w5xrxq7">
                      <Meter value={percent(row.supply, row.demand)} label="Supply against demand" trailing={`${percent(row.supply, row.demand)}%`} tone={row.supply / row.demand < 0.6 ? 'warn' : 'brand'} data-id="element-7177" data-mp="1nxjpp0w73m28" />
                    </div>
                    <p className="cz-num w-24 text-right text-[13px] text-ink-muted" data-id="element-7178" data-mp="1rxu0qryuh2ny">
                      {row.listings} listings
                    </p>
                  </li>)}
              </ul>
            </Panel>

            <Panel title="{institution:plural}" bodyClassName="p-0" data-id="element-7179" data-mp="q4afgfhqs55x">
              <ul className="divide-y divide-line" data-id="element-7180" data-mp="q2z9c90tqlbn">
                {institutions.map(institution => <li key={institution.id} className="flex items-center gap-3 px-5 py-3.5" data-id="element-7181" data-mp="g6nxtl925zi9">
                    <div className="min-w-0 flex-1" data-id="element-7182" data-mp="g4tak0abdvb0">
                      <p className="text-[13px] font-medium text-ink" data-id="element-7183" data-mp="l6imrj99wf0o">{institution.name}</p>
                      <p className="text-[12px] text-ink-muted" data-id="element-7184" data-mp="18wd16598qbn1">
                        {institution.place.city}, {institution.place.state} ·{' '}
                        {institution.campuses.length} campus(es)
                      </p>
                    </div>
                    <Badge tone={institution.integrationLevel === 'full' ? 'ok' : institution.integrationLevel === 'directory' ? 'brand' : 'neutral'} data-id="element-7185" data-mp="13vyp8c4iqhjq">
                      {institution.integrationLevel === 'none' ? 'No integration' : institution.integrationLevel === 'directory' ? 'Directory sync' : 'Full integration'}
                    </Badge>
                  </li>)}
              </ul>
            </Panel>
          </div>
        </div>}

      {tab === 'Moderation' && <div className="grid gap-6 lg:grid-cols-3" data-id="element-7186" data-mp="mnze6g1lmd2j">
          <Panel className="lg:col-span-2" title="Moderation queue" bodyClassName="p-0" data-id="element-7187" data-mp="moin5799tr4f">
            <ul className="divide-y divide-line" data-id="element-7188" data-mp="hnl5cvs6az3g">
              {moderationQueue.map(item => <li key={item.id} className="px-5 py-4" data-id="element-7189" data-mp="cp03krx9w7cw">
                  <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-7190" data-mp="32evfj0n0m7v2">
                    <div className="min-w-0" data-id="element-7191" data-mp="32cr47xmse6kr">
                      <p className="text-[13px] font-semibold text-ink" data-id="element-7192" data-mp="2xez80rf3zyar">{item.subject}</p>
                      <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-7193" data-mp="1cyridstz6jij">{item.reason}</p>
                      <p className="cz-num mt-0.5 text-[12px] text-ink-subtle" data-id="element-7194" data-mp="1hwjivb8ordyc">
                        {item.surface} · {item.reports} report(s) · {item.raised}
                      </p>
                    </div>
                    <div className="flex shrink-0 items-center gap-2" data-id="element-7195" data-mp="1rnxo7znbj7ze">
                      <Badge tone={item.severity === 'High' ? 'danger' : item.severity === 'Medium' ? 'warn' : 'neutral'} data-id="element-7196" data-mp="1wm8ww71vncg1">
                        {item.severity}
                      </Badge>
                      <Button size="sm" variant="secondary" data-id="element-7197" data-mp="b95u9iaixsnz">
                        Review
                      </Button>
                    </div>
                  </div>
                </li>)}
            </ul>
          </Panel>
          <Panel title="Reported accounts" bodyClassName="p-0" data-id="element-7198" data-mp="87jh2ypqxh2p">
            <ul className="divide-y divide-line" data-id="element-7199" data-mp="467pinnbalrv">
              {reportedAccounts.map(item => <li key={item.id} className="flex items-center gap-3 px-5 py-3.5" data-id="element-7200" data-mp="i5h4xl3p1bus">
                  <div className="min-w-0 flex-1" data-id="element-7201" data-mp="d6dxxv45kvk6">
                    <p className="text-[13px] font-medium text-ink" data-id="element-7202" data-mp="d4t467pnxgnd">{item.account}</p>
                    <p className="cz-num text-[12px] text-ink-muted" data-id="element-7203" data-mp="r4knmnyy7p8r">
                      {item.role} · {item.reports} reports
                    </p>
                  </div>
                  <Badge tone={item.state === 'Restricted' ? 'danger' : 'warn'} data-id="element-7204" data-mp="10vyksp3fgcyq">{item.state}</Badge>
                </li>)}
            </ul>
          </Panel>
        </div>}

      {tab === 'Verification' && <Panel title="Verification queue" description="{property:plural}, owners, {employer:plural} and {institution:plural} awaiting checks. Approval states exactly what was verified — never that a {property} was inspected." bodyClassName="p-0" data-id="element-7205" data-mp="1aueaqoqpxg6n">
          <ul className="divide-y divide-line" data-id="element-7206" data-mp="1tgvl59xu6blk">
            {verificationQueue.map(task => <li key={task.id} className="flex flex-wrap items-center gap-3 px-5 py-3.5" data-id="element-7207" data-mp="1fhcgws85bkej">
                <div className="min-w-0 flex-1" data-id="element-7208" data-mp="1kgfks9ce3kkx">
                  <p className="text-[13px] font-semibold text-ink" data-id="element-7209" data-mp="1kjbhxvgey58b">{task.subject}</p>
                  <p className="cz-num mt-0.5 text-[12px] text-ink-muted" data-id="element-7210" data-mp="15qhqdbnv9yna">
                    {task.type} · submitted by {task.submittedBy} on {task.submitted}
                  </p>
                </div>
                <Badge tone={task.status === 'Approved' ? 'ok' : task.status === 'Escalated' ? 'danger' : 'warn'} data-id="element-7211" data-mp="wptdika7m4bz">
                  {task.status}
                </Badge>
                {task.status !== 'Approved' && <Button size="sm" variant="secondary" data-id="element-7212" data-mp="17a1hxlb2767l">
                    Open
                  </Button>}
              </li>)}
          </ul>
        </Panel>}

      {tab === 'Platform' && <Panel title="Audit log" description="Attributed record of administrative, moderation, verification and sensitive-data activity." bodyClassName="p-0" data-id="element-7213" data-mp="tb1swcjmwpaw">
          <DataTable caption="Attributed administrative audit log" rowKey={entry => entry.id} rows={auditLog} columns={[{
        header: 'Actor',
        primary: true,
        cell: entry => entry.actor
      }, {
        header: 'Role',
        cell: entry => entry.actorRole
      }, {
        header: 'Action',
        cell: entry => entry.action
      }, {
        header: 'Target',
        cell: entry => entry.target
      }, {
        header: 'Scope',
        status: true,
        cell: entry => <Badge tone={entry.scope === 'Sensitive data' ? 'danger' : 'neutral'} data-id="element-7215" data-mp="3mnle401n2ilc">
                    {entry.scope}
                  </Badge>
      }, {
        header: 'Time',
        cell: entry => <span className="cz-num" data-id="element-7216" data-mp="5g9izeq0ezdb">{entry.time}</span>
      }]} data-id="element-7214" data-mp="jl9ypjfg5y6y" />
        </Panel>}
    </div>;
}